/**
 * Beats de história na sim (M4). O Palhaço Terrível é mid-boss garantido nos capítulos 3, 5 e 7
 * (doc 03); após o 3º encontro ele vira aliado + destrava a skin "Palhaço Amigo" (persistência: server).
 */
export const PALHACO_CAPS: readonly number[] = [3, 5, 7];
export const PALHACO_ENCONTROS_ALIADO = 3;
export const SKIN_PALHACO_ALIADO = 'palhaco_amigo';

/** há encontro do Palhaço Terrível neste capítulo? */
export function encontroPalhaco(chapter: number): boolean {
  return PALHACO_CAPS.includes(chapter);
}

// Fragmentos de Estrela (AC-M4-03): um por capítulo em 3, 6 e 9. Com os 3, o cap.12 sela o Norno
// (beat final "verdadeiro"); sem os 3, o Norno FOGE (cena alternativa — o pós-jogo abre igual).
export const FRAGMENTO_CAPS: readonly number[] = [3, 6, 9];
export const FRAGMENTOS_TOTAL = 3;

/** há Fragmento de Estrela a coletar neste capítulo? */
export function fragmentoEstrela(chapter: number): boolean {
  return FRAGMENTO_CAPS.includes(chapter);
}

export type DesfechoFinal = 'selado' | 'fugiu';
/** desfecho do beat final conforme os fragmentos reunidos: 3 → selado; <3 → Norno foge. */
export function desfechoFinal(fragmentos: number): DesfechoFinal {
  return fragmentos >= FRAGMENTOS_TOTAL ? 'selado' : 'fugiu';
}
